/**
 * Хук для загрузки прямых видео через proxy с Authorization.
 * YouTube видео не проксируются — для них возвращается оригинальный URL.
 */

import { useEffect, useSyncExternalStore } from 'react';
import { useConfigStore } from '@/store/configStore';
import { mediaLoader } from '@/utils/mediaLoader';
import { isYouTubeUrl } from '@/utils/mediaParser';

export function useVideoProxy(videoUrl: string): string | null {
  const { config } = useConfigStore();

  const isYouTube = isYouTubeUrl(videoUrl);

  const subscribe = (onStoreChange: () => void) =>
    isYouTube ? () => {} : mediaLoader.subscribe(videoUrl, onStoreChange);

  const getSnapshot = (): string | null =>
    isYouTube ? videoUrl : mediaLoader.getCachedUrl(videoUrl);

  const url = useSyncExternalStore(subscribe, getSnapshot, getSnapshot);

  useEffect(() => {
    if (!isYouTube) {
      mediaLoader.load(videoUrl, config.apiKey || undefined);
    }
  }, [videoUrl, config.apiKey, isYouTube]);

  return isYouTube ? videoUrl : url;
}
